import { AxiosResponse } from 'axios';
import BaseService from "@/services/BaseService";
import ServiceResponseEntity from './response-models/ServiceResponseEntity';
import LoginModel from "@/models/LoginModel";
import User from "@/models/User";
export default class LoginService extends BaseService<any> {
    public constructor() {
        super("Afiliado");
    }

    public async login(loginModel: LoginModel): 
    Promise<AxiosResponse<ServiceResponseEntity<User>>> {
        return this.post('Login', loginModel);
    }
}